import React from "react";
import "./styles/login.css";
import LoginCard from "./components/LoginCard";
function LoginMain() {
  return (
    <section className="auth-main-page d-flex align-items-center justify-content-center">
      <LoginCard />
    </section>
  );
}

export default LoginMain;
